var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3 mb-3 text-center"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.mtd_iniciar}},[_vm._v("INICIAR EVALUACIÓN")])])}
var staticRenderFns = []

export { render, staticRenderFns }